import { SecteurEmploiEnum } from '@graphql/generated';
import { SecteurEmploi } from '@lib/models/demande-affiliation/types/secteur-emploi.type';
export class SecteurEmploiMapper {
  public static fromGraphQl(input?: SecteurEmploiEnum): SecteurEmploi | undefined {
    const mapping: Record<string, SecteurEmploi> = {
      AGRICULTURE: 'agriculture',
      INDUSTRIE: 'industrie',
      CONSTRUCTION: 'construction',
      COMMERCE: 'commerce',
      TRANSPORTS: 'transports',
      HEBERGEMENT_ET_RESTAURATION: 'hebergement_et_restauration',
      INFORMATION_ET_COMMUNICATION: 'information_et_communication',
      FINANCE_ASSURANCE_IMMOBILIER: 'finance_assurance_immobilier',
      SERVICES_PRINCIPALEMENT_AUX_ENTREPRISES: 'services_principalement_aux_entreprises',
      ADMINISTRATION_PUBLIQUE: 'administration_publique',
      ENSEIGNEMENT: 'enseignement',
      SANTE: 'sante',
      HEBERGEMENT_MEDICO_SOCIAL_ACTION_SOCIALE:
        'hebergement_medico_social_action_sociale',
      SERVICES_AUX_MENAGES: 'services_aux_menages',
      ACTIVITE_INDETERMINEE: 'activite_indeterminee',
    };
    return input ? mapping[input] : undefined;
  }
}
